<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Salvar"
			:is-confirmar-visivel="isConfirmarVisivel"
			:is-confirmar-desabilitado="isConfirmarDesabilitado"
			:tamanho="modalOptions"
			@close="fecharModal"
		>
			<template #body>
				<div class="my-1" :class="{ ajustar_modal_aba_historico: !$vuetify.breakpoint.mobile }">
					<painel-com-tabs-sem-rotas :tabs="tabs" @tab-atual="botaoSalvarNaoDeveAparecerNaAbaHistorico">
						<template #alteracao>
							<alterar-fornecedor ref="alterarFornecedorRef"></alterar-fornecedor>
						</template>
						<template #historico>
							<historico-alteracao-fornecedor></historico-alteracao-fornecedor>
						</template>
						<template #acoes-tabs>
							<botao-gerar-pdf-historico
								:tipo-historico="tipoHistorico.HISTORICO_ALTERACAO_FORNECEDOR"
								:id-entidade="itemSelecionado.id"
								v-if="!isConfirmarVisivel"
							></botao-gerar-pdf-historico>
						</template>
					</painel-com-tabs-sem-rotas>
				</div>
			</template>
		</modal>
	</v-form>
</template>

<script>
import { TabSemRotaUtils } from '@/core/utils'
import AlterarFornecedor from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/alteracao-fornecedor/alterar-fornecedor/AlterarFornecedor.vue'
import { actionTypes, getterTypes } from '@/core/constants'
import HistoricoAlteracaoFornecedor from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/alteracao-fornecedor/historico/Historico.vue'
import { mapState } from 'vuex'
import validacaoAta from '@/views/mixins/validacaoAta'
import tipoHistorico from '@/core/constants/tipo-historico'
import BotaoGerarPdfHistorico from '@/views/components/botoes/gerar-pdf-historico/BotaoGerarPdfHistorico.vue'

export default {
	name: 'modal-alterar-fornecedor',
	components: { BotaoGerarPdfHistorico, HistoricoAlteracaoFornecedor, AlterarFornecedor },
	mixins: [validacaoAta],
	props: {
		exibir: {
			type: Boolean,
		},
	},
	data() {
		return {
			tabs: [
				new TabSemRotaUtils(1, 'Alteração', 'alteracao', () => this.temPermissaoEdicao),
				new TabSemRotaUtils(2, 'Histórico', 'historico', this.existeHistorico),
			],
			tituloModal: 'Alterar Fornecedor',
			modalOptions: {
				largura: '900',
				altura: '500',
			},
			isConfirmarVisivel: true,
			formIsValid: true,
		}
	},

	computed: {
		tipoHistorico() {
			return tipoHistorico
		},
		...mapState({
			itemSelecionado: (state) => state.itemAta.itemSelecionado,
		}),
		isConfirmarDesabilitado() {
			return !this.formIsValid
		},
	},

	methods: {
		botaoSalvarNaoDeveAparecerNaAbaHistorico(tabValue) {
			const naoEhHistorico = tabValue !== 1

			if (this.temPermissaoEdicao) {
				this.isConfirmarVisivel = naoEhHistorico
			} else {
				this.isConfirmarVisivel = !naoEhHistorico
			}
		},
		fecharModal() {
			this.$emit('carregar-listagem-item')
			this.$emit('fechar-modal')
		},

		async confirmar() {
			if (this.$refs.form.validate()) {
				await this.$store.dispatch(actionTypes.ITEM_ATA.ALTERAR_FORNECEDOR.ALTERAR.INSERIR_NOVO_FORNECEDOR)
				this.$emit('carregar-listagem-item')
				this.fecharModal()
				this.mostrarNotificacaoSucessoDefault()
			}
		},
		existeHistorico() {
			return this.$store.getters[getterTypes.ITEM_ATA.EXISTE_HISTORICO_ALTERAR_FORNECEDOR]
		},
	},
}
</script>

<style lang="stylus" scoped>

.ajustar_modal_aba_historico {
	height: 67vh;
}
</style>
